// src/context/LanguageContext.jsx
import React, { createContext, useContext, useState } from "react";
import { translations } from "../data/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("henki_lang") || "es";
  });

  const toggleLanguage = () => {
    const nextLang = lang === "es" ? "en" : "es";
    setLang(nextLang);
    localStorage.setItem("henki_lang", nextLang);
  };

  const t = (path) => {
    if (!path || typeof path !== "string") return "";
    const keys = path.split(".");

    // Helper to traverse
    const resolve = (obj) => {
      let curr = obj;
      for (const k of keys) {
        if (curr && typeof curr === "object" && k in curr) {
          curr = curr[k];
        } else {
          return undefined;
        }
      }
      return curr;
    };

    const targetObj = translations[lang] || translations.es;
    const result = resolve(targetObj);
    if (result !== undefined) return result;

    const fallbackResult = resolve(translations.es);
    if (fallbackResult !== undefined) return fallbackResult;

    return path;
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
